import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import "./TeenPattiB2020.css";

import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";
export default function TeenpattiB2020() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
  const VIDEO_ID = "teen20b";
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);

  return (
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={VIDEO_ID}
      // VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
      // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
      //  VIDEO_ID={GAME_ID}
      // GAME_ID={GAME_ID}
      // shortName={"cards32a cards32b"}
       gameName={"20-20 Teenpatti B"} 
    >
      {/* <div className="center-main-container casino-page"> */}
      {/* <div className="center-container"> */}
      {/* <div className="casino-page-container teenpatti20"> */}
      {/* <div className="casino-header"> */}
      {/* <span className="casino-name">
              20-20 Teenpatti B
              <a className="ms-1">
                <small>Rules</small>
              </a>
            </span> */}
      {/* <span className="casino-rid d-none d-xl-inline-block">
              <small>
                Round ID: <span>140250501123618</span>
              </small>
            </span> */}
      {/* </div> */}
      {/* <div className="casino-title-header-mobile d-xl-none"> */}
      {/* <ul className="nav nav-tabs menu-tabs">
              <li className="nav-item">
                <div className="nav-link active">Game</div>
              </li>
              <li className="nav-item">
                <div className="nav-link">Placed Bet (0)</div>
              </li>
            </ul> */}
      {/* <div className="pe-2">
              <span className="casino-rid">
                Round ID: <span>140250501123618</span>
              </span>
            </div> */}
      {/* </div> */}
      {/* <div className=""> */}
      {/* <div className="casino-video"> */}
      {/* <div className="video-box-container"> */}
      {/* <div className="casino-video-box"> */}
      {/* <iframe src="/mediaplayer/teen20b/89b5bde7-502b-4496-947d-f17d43cae096?ip=122.160.119.41" /> */}
      {/* </div> */}
      {/* </div> */}
      {/* <div className="casino-video-cards">
                <div className="">
                  <h5>Player A</h5>
                  <div className="flip-card-container">
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-1">
                  <h5>Player B</h5>
                  <div className="flip-card-container">
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
      {/* <div className="clock flip-clock-wrapper">
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div> */}
      {/* </div> */}
      <div className="casino-detail">
        <div className="casino-table">
          <div className="casino-table-box">
            <div className="casino-table-left-box">
              <div className="casino-table-header">
                <div className="casino-nation-detail">Player A</div>
              </div>
              <div className="casino-table-body ">
                <div className="casino-table-row">
                  <div className="casino-odds-box ">
                    Player A
                    <p className="casino-nation-book">
                      {getCasinoPlExposureByRunner(casinoPlData, "Player A")}
                    </p>
                  </div>
                  <div className="casino-odds-box ">
                    3 Baccarat A
                    <p className="casino-nation-book">
                      {getCasinoPlExposureByRunner(
                        casinoPlData,
                        "3 Baccarat A"
                      )}
                    </p>
                  </div>
                  <div className="casino-odds-box ">
                    Total A
                    <p className="casino-nation-book ">
                      {getCasinoPlExposureByRunner(casinoPlData, "Total A")}
                    </p>
                  </div>
                  <div className="casino-odds-box ">
                    Pair Plus A
                    <p className="casino-nation-book ">
                      {getCasinoPlExposureByRunner(casinoPlData, "Pair Plus A")}
                    </p>
                  </div>
                </div>
                <div className="casino-table-row">
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  casinobox ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Player A", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Player A", casinoData, true)}
                    </span> 
                  </div>

                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  casinobox ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("3 Baccarat A", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {getOddForEntity("3 Baccarat A", casinoData, true)}
                    </span>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  casinobox ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Total A", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {getOddForEntity("Total A", casinoData, true)}
                    </span>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back casinobox ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Pair Plus A", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {getOddForEntity("Pair Plus A", casinoData, true)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="teenpatti20-other-oods d-md-none">
              {/* <div className="casino-table-left-box">
                      <div className="casino-odds-box back">
                        <div>
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/spade.png" />
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/club.png" />
                        </div>
                        <div>
                          <span className="casino-odds">{getOddForEntity("Black A", casinoData, true)}</span>
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <div>
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/heart.png" />
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/diamond.png" />
                        </div>
                        <div>
                          <span className="casino-odds">{getOddForEntity("Red A", casinoData, true)}</span>
                        </div>
                      </div>
                    </div> */}
            </div>
            <div className="casino-table-right-box">
              <div className="casino-table-header">
                <div className="casino-nation-detail">Player B</div>
              </div>
              <div className="casino-table-body">
                <div className="casino-table-row">
                  <div className="casino-odds-box">
                    Player B
                    <p className="casino-nation-book ">
                      {getCasinoPlExposureByRunner(casinoPlData, "Player B")}
                    </p>
                  </div>
                  <div className="casino-odds-box">
                    3 Baccarat B
                    <p className="casino-nation-book ">
                      {getCasinoPlExposureByRunner(
                        casinoPlData,
                        "3 Baccarat B"
                      )}
                    </p>
                  </div>
                  <div className="casino-odds-box ">
                    Total B
                    <p className="casino-nation-book ">
                      {getCasinoPlExposureByRunner(casinoPlData, "Total B")}
                    </p>
                  </div>
                  <div className="casino-odds-box ">
                    Pair Plus B
                    <p className="casino-nation-book ">
                      {getCasinoPlExposureByRunner(casinoPlData, "Pair Plus B")}
                    </p>
                  </div>
                </div>
                <div className="casino-table-row">
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back casinobox ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Player B", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {getOddForEntity("Player B", casinoData, true)}
                    </span>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back casinobox  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("3 Baccarat B", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {getOddForEntity("3 Baccarat B", casinoData, true)}
                    </span>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back casinobox  ${
                      casinoData?.data?.response?.autoTime < 5 
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Total B", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {getOddForEntity("Total B", casinoData, true)}
                    </span>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back casinobox ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Pair Plus B", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {getOddForEntity("Pair Plus B", casinoData, true)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="teenpatti20-other-oods d-md-none">
                    <div className="casino-table-right-box">
                      <div className="casino-odds-box back">
                        <div>
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/spade.png" />
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/club.png" />
                        </div>
                        <div>
                          <span className="casino-odds">1.98</span>
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <div>
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/heart.png" />
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/diamond.png" />
                        </div>
                        <div>
                          <span className="casino-odds">1.98</span>
                        </div>
                      </div>
                    </div>
                  </div> */}
          </div>
          <div className="teenpatti20-other-oods d-none d-md-flex">
            <div className="casino-table-left-box">
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back casinobox w-50 ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Black A", casinoData, dispatch, "back")}
              >
                <div>
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/spade.png" />
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/club.png" />
                </div>
                <p className="casino-nation-book ">
                  {getCasinoPlExposureByRunner(casinoPlData, "Black A")}
                </p>

                <div>
                  <span className="casino-odds">
                    {getOddForEntity("Black A", casinoData, true)}
                  </span>
                </div>
              </div>
              {/* <p className="casino-nation-book d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Black A")}
              </p> */}
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back casinobox w-50 ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Red A", casinoData, dispatch, "back")}
              >
                <div>
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/heart.png" />
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/diamond.png" />
                </div>
                <p className="casino-nation-book ">
                  {getCasinoPlExposureByRunner(casinoPlData, "Red A")}
                </p>
                <div>
                  <span className="casino-odds">
                    {getOddForEntity("Red A", casinoData, true)}
                  </span>
                </div>
              </div>
            </div>
        

            {/* <p className="casino-nation-book d-none w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Red A")}
              </p> */}
            <div className="casino-table-right-box w-50">
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back w-50  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Black B", casinoData, dispatch, "back")}
              >
                <div>
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/spade.png" />
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/club.png" />
                </div>
                <p className="casino-nation-book ">
                  {getCasinoPlExposureByRunner(casinoPlData, "Black B")}
                </p>
                <div>
                  <span className="casino-odds">
                    {getOddForEntity("Black B", casinoData, true)}
                  </span>
                </div>
              </div>
              {/* <div className="casino-odds-box back"> */}
              <div className={`casino-odds-box back casinobox w-50 ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Red B", casinoData, dispatch, "back")}
              >
                <div>
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/heart.png" />
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/diamond.png" />
                </div>
                <p className="casino-nation-book ">
                  {getCasinoPlExposureByRunner(casinoPlData, "Red B")}
                </p>
                <div>
                  <span className="casino-odds">
                    {getOddForEntity("Red B", casinoData, true)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="casino-last-result-title">
          <span>Last Result</span>
          <span>
            <a href="/casino-results/teen20b">View All</a>
          </span>
        </div> */}
        {/* <div className="casino-last-results">
          <span className="result result-b">B</span>
          <span className="result result-b">B</span>
          <span className="result result-a">A</span>
          <span className="result result-a">A</span>
          <span className="result result-a">A</span>
          <span className="result result-a">A</span>
          <span className="result result-a">A</span>
          <span className="result result-a">A</span>
          <span className="result result-b">B</span>
          <span className="result result-a">A</span>
        </div> */}
        <div className="sidebar-box my-bet-container mt-2 d-xl-none">
          <div className="sidebar-title">
            <h4>Rules</h4>
          </div>
          <div className="">
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th colSpan={2} className="text-center">
                      Pair Plus
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pair</td>
                    <td>1 TO 1</td>
                  </tr>
                  <tr>
                    <td>Flush</td>
                    <td>1 TO 4</td>
                  </tr>
                  <tr>
                    <td>Straight</td>
                    <td>1 TO 6</td>
                  </tr>
                  <tr>
                    <td>Trio</td>
                    <td>1 TO 30</td>
                  </tr>
                  <tr>
                    <td>Straight Flush</td>
                    <td>1 TO 40</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
      <div className="d-none">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Matched Bet</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
      {/* <div className="sidebar right-sidebar casino-right-sidebar">
        <div className="sidebar-box my-bet-container">
          <div className="sidebar-title">
            <h4>My Bet</h4>
          </div>
          <div className="my-bets">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>Matched Bet</th>
                    <th className="text-end">Odds</th>
                    <th className="text-end">Stake</th>
                  </tr>
                </thead>
                <tbody />
              </table>
            </div>
          </div>
        </div>
        <div className="sidebar-box my-bet-container">
          <div className="sidebar-title">
            <h4>Rules</h4>
          </div>
          <div className="">
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th colSpan={2} className="text-center">
                      Pair Plus
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pair</td>
                    <td>1 TO 1</td>
                  </tr>
                  <tr>
                    <td>Flush</td>
                    <td>1 TO 4</td>
                  </tr>
                  <tr>
                    <td>Straight</td>
                    <td>1 TO 6</td>
                  </tr>
                  <tr>
                    <td>Trio</td>
                    <td>1 TO 30</td>
                  </tr>
                  <tr>
                    <td>Straight Flush</td>
                    <td>1 TO 40</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div> */}
      {/* </div> */}
    </CasinoPage>
  );
}
